import * as URLConfig from "../domain";

const config = URLConfig.config;

export default {
	accounts: config.jmw + config.jmw_login + "accounts/",
	consent: config.jmw + config.jmw_login + "consent/",
	merge: config.jmw + config.jmw_login + "merge/",
	raterm: config.jmw + config.jmw_login + "raterm/",
	commAccOpen: config.jmw + config.jmw_login + "commodity/openaccount/",
	jwttokenfornesttrader: config.web_mw + "Account/jwttokenfornesttrader",
	cAccount: config.web_mw + "CAccount/",
	clevertapRegister: config.web_mw + "CleverTap/RegisterDevice",
	adhoc: config.jmw + config.jmw_content + "adhoc/",
	openAccount: config.rootUrl + "open-trading-account-online"
};
